module.exports = __webpack_public_path__ + "35dcea4a74140282eef2a41fd16a6e23.png";